import React, { useState, useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import withStyles from '@mui/styles/withStyles'

import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Chip from '@mui/material/Chip'

import * as medicRegistrationHttp from '../http/medicregistration'
import * as clinicsHttp from '../http/clinics'
import * as utils from '../utils'
import Loading from '../components/Loading'

const styles = theme => ({
  secao: { padding: theme.spacing(3), marginBottom: theme.spacing(3) }
})

function MedicRegistrations(props) {
  const { classes, user } = props
  const clinicas = props.clinics || []

  const podeGerenciar = utils.user_has_permission(
    user, 'accounts.manage_medicregistration'
  )
  // Quem so conclui (IMAGI) nao convida: mostrar o formulario daria 403 no
  // envio. Quem so convida (clinica) nao ve as abas de fila e licencas.
  const podeConvidar = utils.user_has_permission(
    user, 'accounts.add_medicregistrationinvite'
  )

  const [aba, setAba] = useState(0)
  const [mensagem, setMensagem] = useState(null)
  const [erro, setErro] = useState(null)

  // convite
  const [emailConvite, setEmailConvite] = useState('')
  const [clinicasConvite, setClinicasConvite] = useState([])

  // fila
  const [pendentes, setPendentes] = useState([])
  const [carregandoFila, setCarregandoFila] = useState(false)

  // licenças
  const [licencas, setLicencas] = useState([])

  // médicos de uma clínica
  const [clinicaSelecionada, setClinicaSelecionada] = useState('')
  const [medicos, setMedicos] = useState([])

  const carregarFila = useCallback(async () => {
    if (!podeGerenciar) return
    setCarregandoFila(true)
    const { result, data } = await medicRegistrationHttp.listPending()
    setCarregandoFila(false)
    if (result) setPendentes(data)
    else setErro((data && data.message) || 'Falha ao carregar a fila.')
  }, [podeGerenciar])

  const carregarLicencas = useCallback(async () => {
    if (!podeGerenciar) return
    const { result, data } = await medicRegistrationHttp.listLicenses()
    if (result) setLicencas(data)
  }, [podeGerenciar])

  useEffect(() => {
    clinicsHttp.list()
    carregarFila()
    carregarLicencas()
  }, [carregarFila, carregarLicencas])

  const limpaAvisos = () => { setMensagem(null); setErro(null) }

  // --------------------------------------------------------------- convite
  const enviarConvite = useCallback(async () => {
    limpaAvisos()
    if (!emailConvite.trim()) {
      setErro('Informe o e-mail do médico.')
      return
    }
    if (!clinicasConvite.length) {
      setErro('Selecione a clínica em que o médico irá atuar.')
      return
    }
    const { result, data } = await medicRegistrationHttp.requestInvite(
      emailConvite.trim(), clinicasConvite
    )
    if (result) {
      setMensagem(data.message || 'Convite enviado.')
      setEmailConvite('')
      setClinicasConvite([])
      carregarLicencas()
    } else {
      setErro((data && data.message) || 'Falha ao enviar o convite.')
    }
  }, [emailConvite, clinicasConvite, carregarLicencas])

  // ------------------------------------------------------------------ fila
  const concluir = useCallback(async pendente => {
    limpaAvisos()
    const nome = pendente.first_name + ' ' + pendente.last_name
    const confirmado = window.confirm(
      'Concluir o cadastro de ' + nome + '?\n\n' +
      'Faça isso somente APÓS configurar o PACS. O acesso será criado e o ' +
      'médico e quem enviou o convite serão notificados.'
    )
    if (!confirmado) return

    const { result, data } = await medicRegistrationHttp.concludeRegistration(
      pendente.uuid
    )
    if (result) {
      setMensagem(data.message)
      carregarFila()
      carregarLicencas()
    } else {
      setErro((data && data.message) || 'Falha ao concluir o cadastro.')
    }
  }, [carregarFila, carregarLicencas])

  const descartar = useCallback(async pendente => {
    limpaAvisos()
    const motivo = window.prompt(
      'Descartar este envio (feito por engano)?\n' +
      'Nada será criado e ninguém será notificado.\n\nMotivo (opcional):', ''
    )
    if (motivo === null) return

    const { result, data } = await medicRegistrationHttp.discardRegistration(
      pendente.uuid, motivo
    )
    if (result) {
      setMensagem(data.message)
      carregarFila()
      carregarLicencas()
    } else {
      setErro((data && data.message) || 'Falha ao descartar.')
    }
  }, [carregarFila, carregarLicencas])

  // O endpoint devolve a URL em vez de enviar e-mail: quem repassa ao medico
  // e a IMAGI, pelo canal que ja estiver usando com ele.
  const gerarLinkHwid = useCallback(async medico => {
    limpaAvisos()
    const { result, data } = await medicRegistrationHttp.createHwidLink(
      medico.user_id
    )
    if (result) {
      window.prompt(
        'Link para ' + medico.name + ' informar o codigo do equipamento.\n' +
        'Copie e envie a ele:', data.url
      )
      setMensagem('Link de equipamento gerado para ' + medico.name + '.')
    } else {
      setErro((data && data.message) || 'Falha ao gerar o link.')
    }
  }, [])

  const verAssinatura = useCallback(async uuid => {
    const { result, data } = await medicRegistrationHttp.getSignature(uuid)
    if (result && data) {
      window.open(URL.createObjectURL(data), '_blank', 'noreferrer')
    } else {
      setErro('Não foi possível carregar a assinatura.')
    }
  }, [])

  // -------------------------------------------------------------- licenças
  const salvarLicenca = useCallback(async (clinicId, valor) => {
    limpaAvisos()
    const { result, data } = await medicRegistrationHttp.updateLicense(
      clinicId, valor
    )
    if (result) {
      setMensagem('Licenças atualizadas.')
      carregarLicencas()
    } else {
      setErro((data && data.message) || 'Falha ao atualizar as licenças.')
    }
  }, [carregarLicencas])

  // --------------------------------------------------------------- médicos
  const carregarMedicos = useCallback(async clinicId => {
    setClinicaSelecionada(clinicId)
    setMedicos([])
    if (!clinicId) return
    const { result, data } = await medicRegistrationHttp.listClinicMedics(clinicId)
    if (result) setMedicos(data)
  }, [])

  const removerMedico = useCallback(async medico => {
    limpaAvisos()
    const confirmado = window.confirm(
      'Remover ' + medico.name + ' desta clínica?\n\n' +
      'A licença será liberada e o contador será avisado. O médico continua ' +
      'ativo nas demais clínicas.'
    )
    if (!confirmado) return

    const { result, data } = await medicRegistrationHttp.unlinkMedic(
      clinicaSelecionada, medico.user_id
    )
    if (result) {
      setMensagem(data.message)
      carregarMedicos(clinicaSelecionada)
      carregarLicencas()
    } else {
      setErro((data && data.message) || 'Falha ao remover o médico.')
    }
  }, [clinicaSelecionada, carregarMedicos, carregarLicencas])

  const avisos = (
    <React.Fragment>
      {mensagem && <Box mb={2}><Alert severity="success">{mensagem}</Alert></Box>}
      {erro && <Box mb={2}><Alert severity="error">{erro}</Alert></Box>}
    </React.Fragment>
  )

  return (
    <React.Fragment>
      {/* Fora do bloco de convite: quem so conclui nao ve o formulario, mas
          precisa ver as mensagens de sucesso e erro das proprias acoes. */}
      {avisos}
      {!podeConvidar ? null : (
      <Paper className={classes.secao}>
        <Typography variant="h6" gutterBottom>Convidar médico</Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Um link de cadastro, válido por 5 dias, será enviado ao e-mail
          informado. O convite só é enviado se houver licença disponível.
        </Typography>
        <Grid container spacing={2} alignItems="center" style={{ marginTop: 4 }}>
          <Grid item xs={12} sm={5}>
            <TextField label="E-mail do médico" type="email" fullWidth
              value={emailConvite} onChange={e => setEmailConvite(e.target.value)} />
          </Grid>
          <Grid item xs={12} sm={5}>
            <FormControl fullWidth>
              <InputLabel id="clinicas-convite">Clínicas</InputLabel>
              <Select labelId="clinicas-convite" multiple value={clinicasConvite}
                onChange={e => setClinicasConvite(e.target.value)}
                renderValue={sel => clinicas.filter(c => sel.indexOf(c.id) > -1)
                  .map(c => c.name).join(', ')}>
                {clinicas.map(c => (
                  <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Button variant="contained" fullWidth onClick={enviarConvite}
              style={{ background: '#58b0c0', color: 'white' }}>Enviar</Button>
          </Grid>
        </Grid>
      </Paper>
      )}

      {!podeGerenciar ? null : (
        <Paper className={classes.secao}>
          <Tabs value={aba} onChange={(e, v) => setAba(v)}>
            <Tab label={'Aguardando conclusão (' + pendentes.length + ')'} />
            <Tab label="Licenças" />
            <Tab label="Médicos por clínica" />
          </Tabs>

          {aba === 0 && (
            <Box mt={2}>
              <Alert severity="info" style={{ marginBottom: 12 }}>
                Conclua somente <strong>após configurar o PACS</strong> — é o
                clique que cria o acesso e notifica o médico.
              </Alert>
              {carregandoFila ? <Loading /> : pendentes.length === 0 ? (
                <Typography variant="body2" color="textSecondary">
                  Nenhum cadastro aguardando conclusão.
                </Typography>
              ) : (
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Médico</TableCell>
                      <TableCell>CPF</TableCell>
                      <TableCell>CRM</TableCell>
                      <TableCell>Contato</TableCell>
                      <TableCell>Clínicas</TableCell>
                      <TableCell>Computador</TableCell>
                      <TableCell>Assinatura</TableCell>
                      <TableCell>Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {pendentes.map(p => (
                      <TableRow key={p.uuid}>
                        <TableCell>
                          {p.first_name} {p.last_name}
                          {p.matched_user && (
                            <Chip size="small" label="já cadastrado"
                              style={{ marginLeft: 6 }} />
                          )}
                        </TableCell>
                        <TableCell>{p.cpf}</TableCell>
                        <TableCell>{p.crm} {p.crm_state}</TableCell>
                        <TableCell>{p.email}<br />{p.phone}</TableCell>
                        <TableCell>
                          {(p.clinics || []).map(c => c.name).join(', ')}
                        </TableCell>
                        <TableCell>{p.computer_type}</TableCell>
                        <TableCell>
                          {p.has_signature
                            ? <Button size="small"
                                onClick={() => verAssinatura(p.uuid)}>ver</Button>
                            : '—'}
                        </TableCell>
                        <TableCell>
                          <Button size="small" variant="contained" color="success"
                            style={{ marginRight: 6 }}
                            onClick={() => concluir(p)}>Concluir</Button>
                          <Button size="small" variant="outlined" color="error"
                            onClick={() => descartar(p)}>Descartar</Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </Box>
          )}

          {aba === 1 && (
            <Box mt={2}>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                O uso considera médicos ativos, convites válidos e cadastros
                aguardando conclusão.
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Clínica</TableCell>
                    <TableCell align="center">Contratadas</TableCell>
                    <TableCell align="center">Em uso</TableCell>
                    <TableCell align="center">Disponíveis</TableCell>
                    <TableCell align="center">Alterar</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {licencas.map(l => (
                    <LinhaLicenca key={l.clinic_id} licenca={l}
                      onSalvar={salvarLicenca} />
                  ))}
                </TableBody>
              </Table>
            </Box>
          )}

          {aba === 2 && (
            <Box mt={2}>
              <FormControl style={{ minWidth: 320 }}>
                <InputLabel id="clinica-medicos">Clínica</InputLabel>
                {/* A lista vem das licencas, nao de props.clinics:
                    /api/clinics filtra pelas clinicas de que o usuario e
                    MEMBRO, e quem gerencia o cadastro (IMAGI) nao e membro de
                    nenhuma -- o seletor ficava vazio. O endpoint de licencas
                    devolve todas as clinicas para quem tem a permissao. */}
                <Select labelId="clinica-medicos" value={clinicaSelecionada}
                  onChange={e => carregarMedicos(e.target.value)}>
                  {licencas.map(l => (
                    <MenuItem key={l.clinic_id} value={l.clinic_id}>
                      {l.clinic_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {medicos.length > 0 && (
                <Table size="small" style={{ marginTop: 16 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Médico</TableCell>
                      <TableCell>E-mail</TableCell>
                      <TableCell>CRM</TableCell>
                      <TableCell align="center">Ação</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {medicos.map(m => (
                      <TableRow key={m.user_id}>
                        <TableCell>{m.name}</TableCell>
                        <TableCell>{m.email}</TableCell>
                        <TableCell>{m.crm} {m.crm_state}</TableCell>
                        <TableCell align="center">
                          <Button size="small" variant="outlined"
                            style={{ marginRight: 8 }}
                            onClick={() => gerarLinkHwid(m)}>
                            Novo link de equipamento
                          </Button>
                          <Button size="small" variant="outlined" color="error"
                            onClick={() => removerMedico(m)}>
                            Remover da clínica
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </Box>
          )}
        </Paper>
      )}
    </React.Fragment>
  )
}

// Linha editável da tabela de licenças
function LinhaLicenca(props) {
  const { licenca, onSalvar } = props
  const [valor, setValor] = useState(licenca.max_medics)

  useEffect(() => { setValor(licenca.max_medics) }, [licenca.max_medics])

  return (
    <TableRow>
      <TableCell>{licenca.clinic_name}</TableCell>
      <TableCell align="center">{licenca.max_medics}</TableCell>
      <TableCell align="center">{licenca.in_use}</TableCell>
      <TableCell align="center">
        <Chip size="small" label={licenca.available}
          color={licenca.available > 0 ? 'success' : 'default'} />
      </TableCell>
      <TableCell align="center">
        <TextField type="number" size="small" value={valor}
          onChange={e => setValor(e.target.value)}
          inputProps={{ min: 0, style: { width: 70 } }} />
        <Button size="small" style={{ marginLeft: 8 }}
          onClick={() => onSalvar(licenca.clinic_id, Number(valor))}>
          Salvar
        </Button>
      </TableCell>
    </TableRow>
  )
}

const mapStateToProps = state => ({
  clinics: state.clinics.list || [],
  user: state.auth.currentUser
})

export default connect(mapStateToProps)(withStyles(styles)(MedicRegistrations))
